import { connect } from 'react-redux';
import { formValueSelector } from 'redux-form';
import { hasFeature } from 'components/shared/featureFlag';
import { durationConverter } from 'utils/duration';
import HideStrategyModal from '../../components/modals/hidestrategy';
import { HIDE_STRATEGY_NAMES, } from '../../components/nodeTypes/hidestrategy';
import { HideStrategy } from '../../components/types';
const mapStateToProps = (state, ownProps) => {
    var _a, _b, _c;
    const { node } = ownProps;
    const hasEWTStrategy = hasFeature(state, 'ewt-hide-strategy');
    const hidestrategyValues = [
        {
            id: HideStrategy.ALL_AGENTS_AWAY,
            name: HIDE_STRATEGY_NAMES[HideStrategy.ALL_AGENTS_AWAY],
        },
        {
            id: HideStrategy.ALL_AGENTS_OFFLINE,
            name: HIDE_STRATEGY_NAMES[HideStrategy.ALL_AGENTS_OFFLINE],
        },
        {
            id: HideStrategy.NEVER,
            name: HIDE_STRATEGY_NAMES[HideStrategy.NEVER],
        },
        ...(hasEWTStrategy
            ? [
                {
                    id: HideStrategy.EXPECTED_WAITING_TIME,
                    name: HIDE_STRATEGY_NAMES[HideStrategy.EXPECTED_WAITING_TIME],
                },
            ]
            : []),
    ];
    const strategy = ((_a = node.payload) === null || _a === void 0 ? void 0 : _a.strategy) || null;
    const ewtThreshold = ((_b = node.payload) === null || _b === void 0 ? void 0 : _b.strategy) === HideStrategy.EXPECTED_WAITING_TIME
        ? durationConverter.milliseconds.toSeconds((_c = node.payload) === null || _c === void 0 ? void 0 : _c.ewtThreshold)
        : durationConverter.minutes.toSeconds(10);
    const selector = formValueSelector('chatFlowHideStrategyForm');
    const selectedStrategy = selector(state, 'strategy');
    const initialValues = {
        strategy,
        ewtThreshold,
    };
    return {
        initialValues,
        hidestrategyValues,
        selectedStrategy,
    };
};
export default connect(mapStateToProps)(HideStrategyModal);
